export default __webpack_public_path__ + "static/media/585_2.396756ab.jpg";